import BrowserRouter from '@fuse/core/BrowserRouter';
import FuseLayout from '@fuse/core/FuseLayout';
import FuseTheme from '@fuse/core/FuseTheme';
import { SnackbarProvider } from 'notistack';
import { useSelector } from 'react-redux';
import { selectCurrentLanguageDirection } from 'app/store/i18nSlice';
import themeLayouts from 'app/theme-layouts/themeLayouts';
import { selectMainTheme } from 'app/store/fuse/settingsSlice';
import FuseAuthorization from '@fuse/core/FuseAuthorization';
import withAppProviders from './app/withAppProviders';
import { AuthProvider } from './app/auth/AuthContext';
import { GlobalDataProvider } from './app/providers/GlobalDataProvider';
import { selectUser } from 'app/store/userSlice';
import { LaunchDarklyProvider } from './app/providers/LaunchDarklyProvider';

const App = () => {
  const user = useSelector(selectUser);
  const mainTheme = useSelector(selectMainTheme);
  const langDirection = useSelector(selectCurrentLanguageDirection);

  return (
    <AuthProvider>
      <LaunchDarklyProvider
        userKey={user.id}
        userName={user.displayName}
        licenseeId={user.licenseeId}
      >
        <FuseTheme theme={mainTheme} direction={langDirection}>
          <BrowserRouter>
            <FuseAuthorization userRole={user.role?.name}>
              <SnackbarProvider
                maxSnack={5}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'right',
                }}
                classes={{
                  containerRoot: 'bottom-0 right-0 mb-52 md:mb-68 mr-8 lg:mr-80 z-99',
                }}
              >
                <GlobalDataProvider>
                  <FuseLayout layouts={themeLayouts} />
                </GlobalDataProvider>
              </SnackbarProvider>
            </FuseAuthorization>
          </BrowserRouter>
        </FuseTheme>
      </LaunchDarklyProvider>
    </AuthProvider>
  );
};

export default withAppProviders(App)();
